import { render, staticRenderFns } from "./skill.vue?vue&type=template&id=5fdf1596"
import script from "./skill.vue?vue&type=script&lang=ts"
export * from "./skill.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports